var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('div',{staticClass:"preloader mar-l1"}):_vm._e(),_vm._l((_vm.folders),function(folder){return _c('ui-project-folder-node',_vm._b({key:folder.id},'ui-project-folder-node',{
            selectedEntityId: _vm.selectedEntityId,
            node: folder,
            getNodes: _vm.getFolders,
            getEntities: _vm.getEntities,
            selectEntity: _vm.selectEntity
        },false))})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }